<template>
    <div class="mobile_bottom">
        <!--快捷导航-->
        <div class="block">
            <div class="title">{{ $t('quick_navigation') }}</div>
            <div class="nav_grid">
                <div v-for="item in menuList" :key="item.id" class="nav_item" @click="jump(1, item.path)">
                    {{ item.name }}
                </div>
            </div>
        </div>
        <!--产品分类-->
        <div class="block">
            <div class="title">{{ $t('categories') }}</div>
            <div class="nav_grid">
                <div v-for="item in typeList" :key="item.id" class="nav_item" @click="jump(2, item.id)">
                    {{ item.name }}
                </div>
            </div>
        </div>
        <!--联系方式-->
        <mobile-concat-us></mobile-concat-us>
        <div class="copyright">© {{ year }} {{ $t('footer_copyright') }}</div>
    </div>
</template>
<script>
import MobileConcatUs from "@/components/mobile/MobileConcatUs.vue";
import {reqListProductsType} from "@/api/core/ProductsType";

export default {
    name: "MobileBottom",
    components: {MobileConcatUs},
    async created() {
        await this.loadType();
    },
    methods: {
        jump(type, path) {
            if (type === 1) {
                this.$router.push({path: path});
            } else {
                this.$router.push({path: '/productsType', query: {typeId: path}});
            }
        },
        async loadType() {
            let {data} = await reqListProductsType({});
            this.typeList = data.length > 5 ? data.slice(0, 5) : data;
        },
    },
    data() {
        return {
            typeList: [],
            year: new Date().getFullYear(),
            menuList: [
                {id: 0, name: this.$t('header_menu.home'), path: "/"},
                {id: 1, name: this.$t('header_menu.about'), path: "/about"},
                {id: 2, name: this.$t('header_menu.product'), path: "/productsType"},
                {id: 3, name: this.$t('header_menu.news'), path: "/news"},
                {id: 4, name: this.$t('header_menu.download'), path: "/download"},
                {id: 5, name: this.$t('header_menu.contact'), path: "/concat"},
            ],
        }
    }
}
</script>
<style scoped lang="scss">
.mobile_bottom {
    background: linear-gradient(135deg, #1b4d33 0%, #246543 100%);
    color: rgba(255, 255, 255, .82);
    position: relative;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 4px;
        background: var(--wood);
    }
}
.block {
    padding: 18px 20px;
    border-bottom: 1px solid rgba(255, 255, 255, .12);
}
.title {
    font-size: 15px;
    font-weight: 700;
    margin-bottom: 10px;
    color: var(--wood);
    letter-spacing: 1px;
    text-transform: uppercase;
    padding-bottom: 10px;
    position: relative;

    &::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        width: 28px;
        height: 2px;
        background: var(--wood);
    }
}
.nav_grid {
    display: flex;
    flex-wrap: wrap;
}
.nav_item {
    width: 33.33%;
    font-size: 13px;
    padding: 8px 0;
    color: rgba(255, 255, 255, .78);
    cursor: pointer;

    &:hover {
        color: var(--wood);
    }
}
.copyright {
    text-align: center;
    font-size: 12px;
    color: rgba(255, 255, 255, .55);
    padding: 16px 20px;
    background: rgba(0, 0, 0, .12);
}
</style>
